<template>
  <div v-if="merchant_id === 'liabadmin'" class="mb-5">
    <div class="form-group row mb-3">
      <label class="col-sm-4" for="discount_percent">Kedvezmény százalék: </label>
      <div class="col-sm-4">
        <!-- <ValidationProvider
          name="period_discount"
          v-slot="{errors}"
          rules="required|min:1|max:100"
          :immediate="true"
        > -->
        <div class="input-group mb-3">
          <input
            class="form-control"
            id="discount_percent"
            name="discount_percent"
            v-model="discountPercent"
            type="number"
            min="0"
            max="100"
          />
          <span class="input-group-text" id="currency-addon">%</span>
        </div>
        <!-- <small id="ph_contact_lastname-error" class="text-danger input-alert">{{
            errors[0]
          }}</small>
        </ValidationProvider> -->
      </div>
    </div>
    <div class="form-group row mb-3">
      <label class="col-sm-4">SID értékesítési egység kódja: </label>
      <div class="col-sm-4">
        <!-- <ValidationProvider
          name="period_discount"
          v-slot="{errors}"
          rules="required|min:1|max:100"
          :immediate="true"
          > -->
        <input class="form-control" id="sidagentid" name="sidagentid" v-model="sidAgentId" />
        <!-- <small id="ph_contact_lastname-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
        </ValidationProvider> -->
        <small
          >Ha a SID értékesítési egység kódja nincs kitöltve, akkor a Colonnade lesz az értékesítési
          egység</small
        >
      </div>
    </div>
  </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields';
import {mapActions} from 'vuex';
import RequestPdfButon from './RequestPdfButton.vue';
import SaveLinkButton from './SaveLinkButton.vue';

export default {
  components: {RequestPdfButon, SaveLinkButton},
  computed: {
    ...mapFields(['merchant_id', 'discountPercent', 'sidAgentId']),
    IsDoubleLimit: function() {
      if (this.double_limit === 'double_limit') return 'Igen';
      else return 'Nem';
    },
  },
};
</script>
